export default __webpack_public_path__ + "static/O0268-3f2e5b79e57efe24d32584421976a1a5.png";